// reducers/employeeReducer.js

import { FETCH_EMPLOYEES_FAILURE, FETCH_EMPLOYEES_REQUEST, FETCH_EMPLOYEES_SUCCESS } from "../Actions/Actions";


const initialState = {
  employees: [],
  isLoading: false,
  error: null,
  resendLoading: false,
  resendMessage: null,
  resendError: null,
};

const employeeReducer = (state = initialState, {type,payload}) => {
  switch (type) {
    case FETCH_EMPLOYEES_REQUEST:
      return { ...state, isLoading: true, error: null };
    case FETCH_EMPLOYEES_SUCCESS:
      return { ...state, isLoading: false, employees: payload };
    case FETCH_EMPLOYEES_FAILURE:
      return { ...state, isLoading: false, error: payload };
    case 'RESEND_ACTIVATION_REQUEST':
      return { ...state, resendLoading: true, resendMessage: null, resendError: null };
    case 'RESEND_ACTIVATION_SUCCESS':
      return { ...state, resendLoading: false, resendMessage: payload, resendError: null };
    case 'RESEND_ACTIVATION_FAILURE':
      return { ...state, resendLoading: false, resendMessage: null, resendError: payload };
    default:
      return state;
  }
};

export default employeeReducer;
